import { Card, CardContent, Typography, Stack, Box } from "@mui/material";

// --- view-only location card ---
export default function ViewTermiteLocationCard({ item }) {
  const get = (k) => (item?.[k] ?? "").toString().trim();

  // If the original form saved "Other" + location_other, prefer the free text
  const locationLabel = (() => {
    const loc = get("location");
    const other = get("location_other");
    return loc === "Other" && other ? other : loc || "—";
  })();

  // Only show rows with values
  const rows = [
    { label: "Findings", value: get("findings") },
    { label: "Action Taken", value: get("action_taken") },
    { label: "Bait/Monitor Location", value: get("bait_monitor_location") },
    { label: "Remarks", value: get("remarks") },
  ].filter((r) => r.value);

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardContent sx={{ py: 1.5 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
          {locationLabel}
        </Typography>

        {rows.length > 0 ? (
          <Stack spacing={0.5}>
            {rows.map((row, i) => (
              <Box key={i} sx={{ display: "flex", gap: 1 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ minWidth: 150 }}
                >
                  {row.label}
                </Typography>
                <Typography variant="body2">{row.value}</Typography>
              </Box>
            ))}
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary">
            (No details)
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
